var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContentIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1663 6.12562L8.66625 3.12563C8.43605 2.97204 8.13998 2.95769 7.89601 3.08831C7.65204 3.21892 7.49982 3.47327 7.5 3.75V9.75C7.49982 10.0267 7.65204 10.2811 7.89601 10.4117C8.13998 10.5423 8.43605 10.528 8.66625 10.3744L13.1663 7.37438C13.3752 7.23533 13.5007 7.00098 13.5007 6.75C13.5007 6.49902 13.3752 6.26467 13.1663 6.12562ZM9 8.34844V5.15625L11.3981 6.75L9 8.34844ZM18 0H1.5C0.671573 0 0 0.671573 0 1.5V12C0 12.8284 0.671573 13.5 1.5 13.5H18C18.8284 13.5 19.5 12.8284 19.5 12V1.5C19.5 0.671573 18.8284 0 18 0ZM18 12H1.5V1.5H18V12ZM19.5 15.75C19.5 16.1642 19.1642 16.5 18.75 16.5H0.75C0.335786 16.5 0 16.1642 0 15.75C0 15.3358 0.335786 15 0.75 15H18.75C19.1642 15 19.5 15.3358 19.5 15.75Z",
    fill: "#AD11F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentIcon);
export default __webpack_public_path__ + "static/media/ContentIcon.b739c3416436c225d93ed2d2c9fbb0c5.svg";
export { ForwardRef as ReactComponent };